import { useCallback, useEffect, useState } from 'react';
import { REMOVE_TAG_BUTTON_CLASS } from '../../../constants/constants';

export const useAvatarMultiSelectOperation = (
	value: string[] | [],
	containerRef: React.RefObject<any>
) => {
	const [operationCompleted, setOperationCompleted] = useState(false);
	const updateTabIndex = useCallback(() => {
		const removeTagButtons = containerRef.current.querySelectorAll(
			`button.${REMOVE_TAG_BUTTON_CLASS}`
		);
		if (removeTagButtons) {
			removeTagButtons.forEach((btn: any) => {
				if (btn.closest('div[aria-hidden="true"]')) {
					btn.setAttribute('tabIndex', -1);
				} else {
					btn.setAttribute('tabIndex', 0);
				}
			});
		}
		setOperationCompleted(true);
	}, [containerRef]);

	useEffect(() => {
		if (value?.length > 0 && containerRef?.current) {
			updateTabIndex();
		}
	}, [value, containerRef, updateTabIndex]);

	useEffect(() => {
		const resizeObserver = new ResizeObserver(updateTabIndex);
		const observedNode = containerRef.current;

		if (observedNode) {
			resizeObserver.observe(observedNode);
		}

		return () => {
			if (observedNode) {
				resizeObserver.unobserve(observedNode);
			}
		};
	}, [containerRef, updateTabIndex]);

	return { operationCompleted };
};
